export default __webpack_public_path__ + "static/media/acceX.6f3c4731.svg";